import { render, staticRenderFns } from "./TitleTable_NDW.vue?vue&type=template&id=1b21cfe0&scoped=true&"
import script from "./TitleTable_NDW.vue?vue&type=script&lang=js&"
export * from "./TitleTable_NDW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21cfe0",
  null
  
)

export default component.exports